import * as Yup from 'yup'
import isEmail from 'validator/lib/isEmail'

const yupSetup = () => {
  Yup.addMethod(Yup.string, 'email', function validateEmail(message) {
    return this.test(
      'email',
      message,
      value => isEmail(value ?? ''),
    )
  })
}

export default yupSetup
